import React, { PropsWithChildren } from 'react';

import { css, keyframes } from '@emotion/react';
import { Box } from '@opendoor/bricks/core';

const fade = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

/**
 * Animation wrapper
 *
 * storybook-check-ignore
 */
export const AnimationWrapper: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <Box
      css={css`
        animation: ${fade} 0.5s ease-in;
      `}
      width="100%"
    >
      {children}
    </Box>
  );
};
